module.exports = __webpack_public_path__ + "media/images/icon__point--lost-80157f1fae2d98c1eb09db0a2f87ddc1.png";